import { useContext } from "react";
import { Link } from "react-router-dom";
import "../styles/components/Navbar.css";
import AuthContext from "../context/AuthContext";

const Navbar = () => {
  const { isLoggedIn, logout, login, isLoading } = useContext(AuthContext);

  return (
    <nav className="navbar">
      <div className="navbar-logo">
         <Link to="/" aria-label="soMeet – strona główna">
          <img
            src="/soMeet-home.png"
            alt="soMeet"
            className="logo-img"
            height={50}
            loading="eager"
            decoding="async"
          />
          </Link>
      </div>

      <ul className="navbar-links">
        <li><Link to="/events">Eventy</Link></li>
        <li><Link to="/picnic">Pikniki</Link></li>
        <li><Link to="/aboutus">O nas</Link></li>

        {isLoading ? null : isLoggedIn ? (
          <>
            <li><Link to="/profile">Mój profil</Link></li>
            <li>
              <span onClick={logout} className="navbar-link logout-link">
                Wyloguj się
              </span>
            </li>
          </>
        ) : (
          <>
            <li>
              <span onClick={login} className="navbar-link logout-link">
                Logowanie
              </span>
            </li>
            {/* jeśli rejestracja jest w Auth0, to możesz usunąć /registration */}
            <li><Link to="/registration">Rejestracja</Link></li>
          </>
        )}
      </ul>
    </nav>
  );
};

export default Navbar;
